import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "log"
};
const _hoisted_2 = {
  key: 1,
  class: "content"
};
const _hoisted_3 = {
  class: "line"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = {
  class: "van-ellipsis name"
};
const _hoisted_6 = {
  key: 0,
  class: "amount"
};
const _hoisted_7 = {
  key: 1,
  class: "amount add"
};
const _hoisted_8 = {
  class: "right"
};
const _hoisted_9 = {
  class: "label"
};
const _hoisted_10 = {
  class: "label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NavBar = _resolveComponent("NavBar");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_back_top = _resolveComponent("van-back-top");
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
    title: "交易记录"
  }), _createVNode(_component_van_pull_refresh, {
    modelValue: _ctx.refreshing,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.refreshing = $event),
    "success-text": "刷新成功",
    onRefresh: _ctx.onRefresh
  }, {
    default: _withCtx(() => [!_ctx.list.length ? (_openBlock(), _createBlock(_component_van_empty, {
      key: 0,
      description: "暂无数据"
    })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_list, {
      loading: _ctx.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = $event => _ctx.loading = $event),
      finished: _ctx.finished,
      "finished-text": "没有更多了",
      onLoad: _ctx.onLoad
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.businessTypeName) + " " + _toDisplayString(item.addressName ? " (" + item.addressName + ") " : ""), 1), _createElementVNode("div", null, [item.businessType == '1' || item.businessType == '3' || item.businessType == '4' ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_cache[2] || (_cache[2] = _createElementVNode("span", null, "-", -1)), _createTextVNode(_toDisplayString(item.amount), 1)])) : (_openBlock(), _createElementBlock("span", _hoisted_7, [_cache[3] || (_cache[3] = _createElementVNode("span", null, "+", -1)), _createTextVNode(_toDisplayString(item.amount), 1)]))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.businessTime), 1), _createElementVNode("div", _hoisted_10, "账户余额：" + _toDisplayString(item.amountTotal), 1)])]), _createVNode(_component_van_divider, {
          hairline: "",
          style: {
            margin: 0
          }
        })]);
      }), 128))]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"]), _createVNode(_component_van_back_top)]))]),
    _: 1
  }, 8, ["modelValue", "onRefresh"])]);
}